import { render, staticRenderFns } from "./biddingArticles.vue?vue&type=template&id=7f8be20f&scoped=true"
import script from "./biddingArticles.vue?vue&type=script&lang=js"
export * from "./biddingArticles.vue?vue&type=script&lang=js"
import style0 from "./biddingArticles.vue?vue&type=style&index=0&id=7f8be20f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8be20f",
  null
  
)

export default component.exports